module.exports = __webpack_public_path__ + "static/media/404leaf.37701ae7.png";